import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import CustomLoader from "../../Components/custom/CustomLoader";
import PaginationControl from "../../Components/custom/PaginationControl";
import Select from "react-select";
import moment from "moment";
import { useFetch } from "../../hooks/queries";
import { FaFileExcel, FaChartBar, FaArrowLeft, FaFilter } from "react-icons/fa";
import { toast } from "react-toastify";

const TeacherCompetencyReport = (props) => {
  const [showReport, setShowReport] = useState(false);
  const [perPage, setPerPage] = useState(20);
  const [page, setPage] = useState(1);
  const [competencyResponse, setCompetencyResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const [selectedSchool, setSelectedSchool] = useState({
    label: "All Schools",
    value: 0,
  });
  const [selectedOperator, setSelectedOperator] = useState({
    label: "N/A",
    value: 0,
  });

  const handleFilterApply = ({ operator, school }) => {
    setSelectedOperator(operator || { label: "N/A", value: 0 });
    setSelectedSchool(school || { label: "All Schools", value: 0 });
    setPage(1);
  };

  const getFilterIds = () => {
    const ot = localStorage.getItem("OTsReD");
    const st = localStorage.getItem("STsReD");
    const safeParseInt = (value) => {
      const parsed = parseInt(value);
      return isNaN(parsed) ? 0 : parsed;
    };
    const parsedOt = safeParseInt(ot);
    const parsedSt = safeParseInt(st);

    if (parsedOt !== 0 && parsedSt === 0) {
      return {
        operatorId: parsedOt,
        schoolId: safeParseInt(selectedSchool.value),
      };
    } else if (parsedOt !== 0 && parsedSt !== 0) {
      return { operatorId: parsedOt, schoolId: parsedSt };
    } else {
      return {
        operatorId: safeParseInt(selectedOperator.value),
        schoolId: safeParseInt(selectedSchool.value),
      };
    }
  };
  // ── Inline horizontal filter data ──────────────────────────────────────
  const { data: operatorsResponse } = useFetch({
    queryKey: ["report-filter-operators"],
    url: process.env.REACT_APP_API_URL + "Operators/GetDLLOperators",
    method: "GET",
  });

  const { data: schoolsResponse } = useFetch({
    queryKey: ["report-filter-schools"],
    url: process.env.REACT_APP_API_URL + "Schools/GetDLLSchools",
    method: "GET",
  });

  const [filterSchools, setFilterSchools] = useState([]);
  const [filterOperators, setFilterOperators] = useState([]);
  const [selectedTempSchool, setSelectedTempSchool] = useState({
    label: "All Schools",
    value: 0,
  });
  const [selectedTempOperator, setSelectedTempOperator] = useState({
    label: "N/A",
    value: 0,
  });

  useEffect(() => {
    if (!operatorsResponse || operatorsResponse.statusCode !== 200) return;
    const content = operatorsResponse.content || [];
    const storedOperator = localStorage.getItem("OTsReD");
    if (storedOperator != null && storedOperator !== "null") {
      const filtered = content.filter(
        (i) => String(i.value) === String(storedOperator),
      );
      setFilterOperators(filtered);
      if (filtered.length > 0) setSelectedTempOperator(filtered[0]);
    } else {
      setFilterOperators(content);
    }
  }, [operatorsResponse]);

  useEffect(() => {
    if (!schoolsResponse || schoolsResponse.statusCode !== 200) return;
    const content = schoolsResponse.content || [];
    const storedSchool = localStorage.getItem("STsReD");
    const storedOperator = localStorage.getItem("OTsReD");
    if (storedSchool != null && storedSchool !== "null") {
      const filtered = content.filter(
        (i) => String(i.value) === String(storedSchool),
      );
      setFilterSchools([{ label: "All Schools", value: 0 }, ...filtered]);
      if (filtered.length > 0) setSelectedTempSchool(filtered[0]);
    } else if (storedOperator != null && storedOperator !== "null") {
      const filtered = content.filter(
        (i) => String(i.operatorId) === String(storedOperator),
      );
      setFilterSchools([{ label: "All Schools", value: 0 }, ...filtered]);
    } else {
      setFilterSchools([{ label: "All Schools", value: 0 }, ...content]);
    }
  }, [schoolsResponse]);

  const storedOperatorId = localStorage.getItem("OTsReD");
  const selectedTempOperatorId = String(selectedTempOperator.value || 0);
  const filterSchoolOptions =
    storedOperatorId !== "null" && storedOperatorId != null
      ? filterSchools
      : selectedTempOperatorId === "0"
        ? filterSchools
        : filterSchools.filter(
            (f) =>
              f.value === 0 || String(f.operatorId) === selectedTempOperatorId,
          );
  // ─────────────────────────────────────────────────────────────────────────

  const columns = [
    {
      id: "courseName",
      name: "Course Name",
      selector: (row) => row.courseName,
      sortable: true,
      wrap: true,
      minWidth: "200px",
    },
    {
      id: "department",
      name: "Department",
      selector: (row) => row.department,
      sortable: true,
      wrap: true,
      minWidth: "180px",
    },
    {
      id: "teacherName",
      name: "Teacher Name",
      selector: (row) => row.teacherName,
      sortable: true,
      minWidth: "180px",
    },
    {
      id: "teacherSISId",
      name: "Teacher SIS ID",
      selector: (row) => row.teacherSISId,
      sortable: true,
      minWidth: "220px",
    },
    {
      id: "publishedAssignmentTitle",
      name: "Published Assignment",
      selector: (row) => row.publishedAssignmentTitle || "N/A",
      sortable: true,
      wrap: true,
      minWidth: "200px",
    },
    {
      id: "publishedQuizTitle",
      name: "Published Quiz",
      selector: (row) => row.publishedQuizTitle || "N/A",
      sortable: true,
      wrap: true,
      minWidth: "180px",
    },

    {
      id: "lastAnnouncement",
      name: "Announcement",
      selector: (row) => row.lastAnnouncement || "N/A",
      sortable: false,
      wrap: true,
      minWidth: "200px",
    },

    {
      id: "submissionStartDate",
      name: "Start Date",
      selector: (row) =>
        row.submissionStartDate
          ? moment(row.submissionStartDate).format("YYYY-MM-DD HH:mm")
          : "N/A",
      sortable: true,
      minWidth: "160px",
    },
    {
      id: "submissionEndDate",
      name: "End Date",
      selector: (row) =>
        row.submissionEndDate
          ? moment(row.submissionEndDate).format("YYYY-MM-DD HH:mm")
          : "N/A",
      sortable: true,
      minWidth: "160px",
    },
    {
      id: "isLinkedToOutcomes",
      name: "Linked to Outcomes",
      selector: (row) => row.isLinkedToOutcomes,
      sortable: true,
      minWidth: "140px",
      cell: (row) => (
        <span
          className={`badge ${
            row.isLinkedToOutcomes === "Yes" ? "bg-success" : "bg-secondary"
          }`}
        >
          {row.isLinkedToOutcomes}
        </span>
      ),
    },
    {
      id: "assignmentCompletionStatus",
      name: "Completion Status",
      selector: (row) => row.assignmentCompletionStatus,
      sortable: true,
      minWidth: "160px",
      cell: (row) => {
        const status = row.assignmentCompletionStatus;
        let badgeClass = "bg-secondary";
        if (status === "Completed/Graded") {
          badgeClass = "bg-success";
        } else if (status === "Pending") {
          badgeClass = "bg-warning";
        }
        return <span className={`badge ${badgeClass}`}>{status}</span>;
      },
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const { operatorId, schoolId } = getFilterIds();
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}Courses/GetTeacherCompetency?PageNumber=${page}&PageSize=${perPage}&OperatorId=${operatorId}&SchoolId=${schoolId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch");
        }

        const result = await response.json();
        setCompetencyResponse(result);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [showReport, page, perPage, selectedSchool.value, selectedOperator.value]);

  const competencyData = competencyResponse?.data || [];
  const totalRows = competencyResponse?.totalCount || 0;

  const isDataLoading = isLoading;

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1);
  };

  const downloadExcelFile = (data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const fileName = `TeacherCompetency_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.download = fileName;
      link.click();
      document.body.removeChild(link);
    }
  };

  const downloadFileFromUrl = (fileUrl, fileName) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", fileName);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExport = async () => {
    setIsExporting(true);
    try {
      const { operatorId, schoolId } = getFilterIds();
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}Courses/ExportTeacherCompetency?OperatorId=${operatorId}&SchoolId=${schoolId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to export");
      }

      const result = await response.json();

      if (result.fileUrl && result.fileName) {
        downloadFileFromUrl(result.fileUrl, result.fileName);
        toast.success(result.message || "Export completed successfully!");
      } else {
        console.error("Invalid response format:", result);
        toast.error("Export completed but file information is missing.");
      }
    } catch (error) {
      console.error("Export failed:", error);
      toast.error("Failed to export data. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  const handleGenerateReport = () => {
    setShowReport(true);
  };

  const handleBack = () => {
    if (showReport) {
      setShowReport(false);
    } else {
      window.history.back();
    }
  };

  // Landing Card - Show before generating report
  if (!showReport) {
    return (
      <div className="container-fluid mt-30">
        <div className="row">
          <div className="col-12 col-md-4">
            <div
              className="card"
              style={{
                borderRadius: "15px",
                boxShadow:
                  "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)",
                border: 0,
              }}
            >
              <div
                className="card-header"
                style={{
                  backgroundColor: "#287a9f",
                  color: "white",
                  borderRadius: "15px 15px 0 0",
                  minHeight: "44px",
                  borderBottom: 0,
                }}
              >
                <h3
                  className="card-title mb-0"
                  style={{ fontSize: "18px", fontWeight: "bold" }}
                >
                  <FaChartBar className="me-2" />
                  Teacher Competency
                </h3>
              </div>
              <div
                className="card-body text-center"
                style={{ padding: "20px 15px" }}
              >
                <FaChartBar
                  size={48}
                  style={{ color: "#287a9f" }}
                  className="mb-3"
                />
                <p className="text-muted mb-3" style={{ fontSize: "14px" }}>
                  Generate comprehensive teacher competency report
                </p>
                <button
                  className="cts-btn-primary btn px-4"
                  onClick={handleGenerateReport}
                  style={{
                    backgroundColor: "#1badba",
                    border: 0,
                    borderRadius: 0,
                    color: "white",
                  }}
                >
                  <FaChartBar className="me-2" />
                  Generate Report
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Report View - Show after clicking generate
  return (
    <div className="container-fluid mt-30">
      <button
        className="btn btn-outline-secondary mb-3 d-flex align-items-center gap-2"
        onClick={handleBack}
        style={{
          borderRadius: "8px",
          border: "1px solid #287a9f",
          color: "#287a9f",
          backgroundColor: "transparent",
        }}
      >
        <FaArrowLeft />
        Back to Report Selection
      </button>

      <div
        className="card"
        style={{
          borderRadius: "15px",
          boxShadow:
            "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)",
          border: 0,
        }}
      >
        <div
          className="card-header"
          style={{
            backgroundColor: "#287a9f",
            color: "white",
            borderRadius: "15px 15px 0 0",
            minHeight: "44px",
            borderBottom: 0,
          }}
        >
          <h3
            className="card-title mb-0"
            style={{ fontSize: "18px", fontWeight: "bold" }}
          >
            <FaChartBar className="me-2" />
            Teacher Competency Report
          </h3>
        </div>
        <div className="card-body">
          {/* Horizontal Filter Row */}
          <div
            className="rounded mb-4 p-3"
            style={{
              backgroundColor: "#f8f9fa",
              border: "1px solid #e9ecef",
            }}
          >
            <div className="row align-items-end g-3">
              {/* <div
                className="col-auto d-flex align-items-center"
                style={{ paddingBottom: "2px" }}
              >
                <FaFilter style={{ color: "#287a9f", fontSize: "16px" }} />
                <span
                  className="ms-2 fw-semibold"
                  style={{
                    color: "#287a9f",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  Filter
                </span>
              </div> */}

              {filterOperators.length > 1 && (
                <div className="col-md-3">
                  <label
                    className="form-label mb-1"
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      color: "#555",
                      textTransform: "uppercase",
                      letterSpacing: "0.4px",
                    }}
                  >
                    Operator
                  </label>
                  <Select
                    options={filterOperators}
                    value={selectedTempOperator}
                    onChange={(e) => {
                      setSelectedTempOperator(e || { label: "N/A", value: 0 });
                      setSelectedTempSchool({ label: "All Schools", value: 0 });
                    }}
                    isClearable={filterOperators.length > 1}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                        minHeight: "auto",
                      }),
                    }}
                  />
                </div>
              )}

              {filterSchools.length > 1 && (
                <div className="col-md-3">
                  {/* <label
                    className="form-label mb-1"
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      color: "#555",
                      textTransform: "uppercase",
                      letterSpacing: "0.4px",
                    }}
                  >
                    School
                  </label> */}
                  <Select
                    options={filterSchoolOptions}
                    value={selectedTempSchool}
                    placeholder="All Schools"
                    onChange={(e) =>
                      setSelectedTempSchool(
                        e || { label: "All Schools", value: 0 },
                      )
                    }
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>
              )}

              <div className="col-auto">
                <button
                  className="btn btn-md cts-btn-primary-3"
                  style={{ minWidth: "110px" }}
                  onClick={() =>
                    handleFilterApply({
                      operator: selectedTempOperator,
                      school: selectedTempSchool,
                    })
                  }
                  disabled={isDataLoading}
                >
                  {isDataLoading ? "Loading..." : "Apply Filter"}
                </button>
              </div>

              <div className="col-auto ms-auto">
                <button
                  className="btn btn-md d-flex align-items-center gap-2"
                  onClick={handleExport}
                  disabled={isExporting || isDataLoading}
                  style={{
                    backgroundColor: "#28848f",
                    border: 0,
                    borderRadius: "4px",
                    color: "white",
                    minWidth: "140px",
                  }}
                >
                  <FaFileExcel />
                  {isExporting ? "Exporting..." : "Export to Excel"}
                </button>
              </div>
            </div>
          </div>

          {/* Data Table */}
          <DataTable
            data={competencyData}
            columns={columns}
            progressPending={isDataLoading}
            progressComponent={<CustomLoader />}
            responsive
            striped
            highlightOnHover
            noDataComponent={
              <div className="py-4 text-center text-muted">
                No teacher competency data available
              </div>
            }
          />

          {/* Pagination */}
          <PaginationControl
            totalCount={totalRows}
            currentPage={page}
            pageSize={perPage}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePerRowsChange}
            pageSizeOptions={[50, 100, 200, 500]}
            disabled={isDataLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default TeacherCompetencyReport;
